import React, { useState } from "react";
import HelloText from "../components/HelloText";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import useSWR from "swr";
const MenuCategorySinlge = () => {
    let params = useParams();
    const { data, error } = useSWR(
        process.env.REACT_APP_DEF_URL + "menu?link=" + params.singleId
      );
      const [name, setName] = useState();
      const [Image, setImage] = useState();
      const [description, setDescription] = useState()
      const [link, setLink] = useState()
      const avatarHandle = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.addEventListener("load", function () {
          setImage(this.result);
        });
        reader.readAsDataURL(file);
      };
      const API_URL = "https://api.metincevener.com/img"
      const UPLOAD_ENDPOINT = "ckup/ckup"
      function uploadAdapter(loader) {
        return {
          upload: () => {
            return new Promise((resolve, reject) => {
              const body = new FormData();
              loader.file.then((file) => {
                body.append("uploadImg", file);
                // let headers = new Headers();
                // headers.append("Origin", "http://localhost:3000");
                fetch(`${API_URL}/${UPLOAD_ENDPOINT}`, {
                  method: "post",
                  body: body
                  // mode: "no-cors"
                })
                  .then((res) => res.json())
                  .then((res) => {
                    resolve({
                      default: `${API_URL}/${res.filename}`
                    });
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
            });
          }
        };
      }
      function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
          return uploadAdapter(loader);
        };
      }
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <>
      <HelloText />
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "menuupdate.php"}
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
        autoComplete="off"
        encType="multipart/form-data"
      >
        {Image ? (
          <img
            id="blah"
            src={Image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        ) : (
          <img
            id="blah"
            src={data.body_image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        )}
        <Button variant="contained" component="label">
        Resim yükle
        <input
          hidden
          accept="image/*"
          multiple
          type="file"
          name="body_image"
          onChange={avatarHandle}
        />
         <input
          hidden
          name="body_id"
          value={data.body_id}
        />
        </Button>
        <TextField
          id="outlined-basics"
          label="Başlık"
          variant={"outlined"}
          fullWidth
          name="body_name"
          onChange={(e) => setName(e.target.value)}
          defaultValue={data.body_name}
          value={name}
        />
        <TextField
          id="outlined-basics"
          label="Açıklama"
          variant={"outlined"}
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          name="body_description"
          onChange={(e) => setDescription(e.target.value)}
          defaultValue={data.body_description}
          value={description}
        />
        <TextField
          id="outlined-basics"
          label="Link"
          variant={"outlined"}
          fullWidth
          name="body_link"
          onChange={(e) => setLink(e.target.value)}
          defaultValue={data.body_link}
          value={link}
        />
        <Button variant="outlined" type="submit">
          Güncelle
        </Button>
      </Box>
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL+"menudelete.php"}
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
      >
        <input type={"hidden"} name="body_id" value={data.body_id} />
        <p style={{color:"red", marginTop:"50px"}}> Bu buton bu içeriği tamamen silecektir. Bu işlem hiçbir şekilde geri alınamaz.</p>
        <Button variant="outlined" type="submit" color="error" style={{
          
        }}>
          Sil
        </Button>
      </Box>
    </>
  );
};

export default MenuCategorySinlge;
